import { isNil, propOr } from 'ramda';
import { api, fetchParams } from '@/modules/helper';

export default {
  namespaced: true,

  state: {},

  mutations: {},

  getters: {},

  actions: {
    fetch({}, params) {
      return api.get('log', { params }).catch(error => error);
    },

    exportData({ state }, payload) {
      const shop_id = propOr([], 'shop_id', payload);
      const params = fetchParams(state, payload, {
        shop_id: shop_id.filter(id => !isNil(id)),
      });

      return api.get('user/export', {
        responseType: 'blob',
        params,
      });
    },
  },
};
